"use strict";
"use client";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Presentations_exports = {};
__export(Presentations_exports, {
  Presentations: () => Presentations,
  useWebPresentations: () => useWebPresentations
});
module.exports = __toCommonJS(Presentations_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var WebPresentationsContext = /* @__PURE__ */ (0, import_react.createContext)(void 0);
function Presentations(param) {
  var { web, children } = param;
  var sheet = web === null || web === void 0 ? void 0 : web.sheet;
  var modal = web === null || web === void 0 ? void 0 : web.modal;
  var value = (0, import_react.useMemo)(function() {
    return sheet || modal ? {
      sheet,
      modal
    } : void 0;
  }, [
    sheet,
    modal
  ]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(WebPresentationsContext.Provider, {
    value,
    children
  });
}
function useWebPresentations() {
  return (0, import_react.useContext)(WebPresentationsContext);
}
//# sourceMappingURL=Presentations.js.map
